module.exports = __webpack_public_path__ + "static/media/complaint-message-icon.f590de17.svg";